import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  guides: [],
};

export const GuideSlice = createSlice({
  name: 'guides',
  initialState,
  reducers: {
    addGuide: (state, action) => {
      state.guides.push(action.payload);
    },
    addGuides: (state, action) => {
      state.guides = action.payload.guides;
    },
    updateGuide: (state, action) => {
      const { id, newData } = action.payload;
      const index = state.guides.findIndex(guide => guide.id === id);
      if (index !== -1) {
        state.guides[index] = { ...state.guides[index], ...newData };
      }
    },
  },
});

export const { addGuide, addGuides, updateGuide } = GuideSlice.actions;

export default GuideSlice.reducer;